document.addEventListener("DOMContentLoaded", () => {
  let giftDatePicker = document.getElementById("deliveryDate");
  if (giftDatePicker) {
    var picker = new Pikaday({
      field: document.getElementById("deliveryDate"),
      format: "MM/DD/YYYY",
      setDefaultDate: true,
      defaultDate: new Date(),
      minDate: new Date(),
      onSelect: function () {
        console.log(this.getMoment().format("MM/DD/YYYY"));
      },
    });
  }

  const thumbsGallery = new Swiper(".thumbs-gallery", {
    spaceBetween: 8,
    slidesPerView: "auto",
  });

  const mainGallery = new Swiper(".main-gallery", {
    slidesPerView: 1,
    navigation: {
      nextEl: ".main-gallery-next",
      prevEl: ".main-gallery-prev",
    },
    pagination: {
      el: ".main-gallery-pagination",
      type: "progressbar",
    },
    thumbs: {
      swiper: thumbsGallery,
      watchSlidesProgress: true,
      slideToClickedSlide: true,
    },
  });

  //variant picker
  const variantPicker = document.querySelectorAll(".variant-picker");

  function syncVariant(selectedID, selectedText, price) {
    // Klaviyo BIS reads the current variant from <input name="id"> — keep it in sync
    // or BIS will refuse to bind the trigger on multi-variant products.
    const klaviyoVariantInput = document.querySelector('input[name="id"]');
    if (klaviyoVariantInput && selectedID) {
      klaviyoVariantInput.value = selectedID;
    }

    document.querySelectorAll(".variant-picker.multi-variant").forEach((p) => {
      p.querySelectorAll(".multi-variant-select").forEach((sel) => {
        const textNode =
          sel.querySelector("span") || sel.querySelector(".selected");
        if (textNode) textNode.textContent = selectedText;

        sel.setAttribute("data-variant-selected", selectedText);
        sel.setAttribute("data-variant-id", selectedID);
      });

      const dd = p.querySelector(".multi-variant-dropdown");
      if (dd) {
        dd.classList.add("hidden");
        dd.querySelectorAll("button[data-variant-id]").forEach((btn) => {
          const isActive = btn.getAttribute("data-variant-id") === selectedID;
          btn.classList.toggle("active", isActive);
          btn.setAttribute("aria-selected", isActive ? "true" : "false");
        });
      }
    });

    if (price) {
      document.querySelectorAll(".product-price").forEach((el) => {
        el.textContent = price;
      });
    }
  }

  variantPicker.forEach((picker) => {
    if (picker.classList.contains("multi-variant")) {
      const multiVariantSelect = picker.querySelector(".multi-variant-select");
      const multiVariantDropdown = picker.querySelector(
        ".multi-variant-dropdown"
      );
      const variantOptions = multiVariantDropdown.querySelectorAll("button");

      multiVariantSelect.addEventListener("click", () => {
        multiVariantDropdown.classList.toggle("hidden");
      });

      variantOptions.forEach((option) => {
        option.addEventListener("click", () => {
          const selectedText = option.textContent.trim();
          const selectedID = option.getAttribute("data-variant-id");
          const price = option.dataset.variantPrice;

          let isAvailable = option.getAttribute("data-isAvailable");
          isAvailableProduct(isAvailable);

          syncVariant(selectedID, selectedText, price);
        });
      });
    } else if (picker.classList.contains("simple-variant")) {
      const variantPickers = document.querySelectorAll(".variant-picker");

      variantPickers.forEach((picker) => {
        const variantRadios = picker.querySelectorAll('input[type="radio"]');

        variantRadios.forEach((radio) => {
          radio.addEventListener("change", () => {
            let isAvailable = radio.getAttribute("data-isAvailable");
            isAvailableProduct(isAvailable);

            const value = radio.value;
            const price = radio.dataset.variantPrice;

            // Keep Klaviyo BIS variant input in sync
            const klaviyoVariantInput = document.querySelector(
              'input[name="id"]'
            );
            if (klaviyoVariantInput) {
              klaviyoVariantInput.value = value;
            }

            document
              .querySelectorAll(
                `.variant-picker input[type="radio"][value="${value}"]`
              )
              .forEach((r) => {
                r.checked = true;

                const lbl = r.closest("label");
                if (lbl) lbl.classList.toggle("active", r.checked);
              });

            if (price) {
              document.querySelectorAll(".product-price").forEach((el) => {
                el.textContent = price;
              });
            }
          });
        });
      });
    }
  });

  // Ensure initial button state reflects the currently selected variant
  applyAvailabilityFromCurrentSelection();

  function isAvailableProduct(isAvailable) {
    const unavailable = String(isAvailable) === "false";
    const OFFSCREEN_CLASSES = [
      "absolute",
      "opacity-0",
      "pointer-events-none",
    ];

    document.querySelectorAll(".add-to-cart-button").forEach((btn) => {
      const container = btn.parentElement;
      const klaviyoTrigger = container?.querySelector(".klaviyo-bis-trigger");

      if (klaviyoTrigger) {
        // Swap mode: cart button when available, Klaviyo BIS trigger when not.
        // We never apply display:none to the trigger so Klaviyo's onsite SDK can
        // bind/keep its click handler regardless of state — instead we push it
        // off-screen visually and make it inert.
        btn.classList.toggle("hidden", unavailable);
        btn.disabled = unavailable;

        OFFSCREEN_CLASSES.forEach((cls) => {
          klaviyoTrigger.classList.toggle(cls, !unavailable);
        });
        if (unavailable) {
          klaviyoTrigger.removeAttribute("aria-hidden");
          klaviyoTrigger.removeAttribute("tabindex");
        } else {
          klaviyoTrigger.setAttribute("aria-hidden", "true");
          klaviyoTrigger.setAttribute("tabindex", "-1");
        }
      } else {
        // Standalone mode (e.g. sticky conversion bar has no Klaviyo sibling):
        // mutate button state in place.
        const buttonText = btn.querySelector(".button-text");
        btn.disabled = unavailable;
        btn.classList.toggle("bg-darkGrey", unavailable);
        btn.classList.toggle("text-white", unavailable);
        btn.classList.toggle("bg-accentBlue", !unavailable);
        const label = unavailable ? "OUT OF STOCK" : "ADD TO BAG";
        if (buttonText) {
          buttonText.innerHTML = label;
        } else {
          btn.innerHTML = label;
        }
      }
    });
  }

  function applyAvailabilityFromCurrentSelection() {
    // Try simple-variant radios first
    const checkedRadio = document.querySelector(
      '.variant-picker.simple-variant input[type="radio"]:checked'
    );
    if (checkedRadio) {
      const isAvailable = checkedRadio.getAttribute("data-isavailable");
      if (isAvailable !== null) {
        isAvailableProduct(isAvailable);
        return;
      }
    }

    // Fallback: multi-variant active/selected option
    const activeMultiBtn = document.querySelector(
      '.multi-variant-dropdown button[aria-selected="true"]'
    );
    if (activeMultiBtn) {
      const isAvailable = activeMultiBtn.getAttribute("data-isavailable");
      if (isAvailable !== null) {
        isAvailableProduct(isAvailable);
      }
    }
  }

  // Product QTY
  let productQTY = document.querySelectorAll(".product-qty");

  productQTY.forEach((productQTY) => {
    let selectedQTY = productQTY.querySelector(".selected");
    let dropdownQTY = productQTY.querySelector(".dropdown");
    let qtySpan = selectedQTY.querySelector("span");
    let qtyButtons = dropdownQTY.querySelectorAll("button[data-qty]");

    selectedQTY.addEventListener("click", () => {
      dropdownQTY.classList.toggle("hidden");
    });

    qtyButtons.forEach((button) => {
      button.addEventListener("click", () => {
        let qty = button.getAttribute("data-qty");

        document.querySelectorAll(".product-qty").forEach((block) => {
          let sel = block.querySelector(".selected");
          let span = sel.querySelector("span");
          let dd = block.querySelector(".dropdown");

          span.textContent = qty;
          sel.setAttribute("data-qty-selected", qty);
          dd.classList.add("hidden");
        });
      });
    });
  });

  // Product accordion
  const productAccordionTabs = document.querySelectorAll(
    ".product-accordion-tab"
  );
  const productAccordionContents = document.querySelectorAll(
    ".product-accordion-content"
  );

  productAccordionTabs.forEach((tab, index) => {
    tab.addEventListener("click", () => {
      productAccordionTabs.forEach((t) => {
        t.classList.remove("border-navy", "opacity-100");
        t.classList.add("border-transparent", "opacity-70");
      });

      tab.classList.add("border-navy", "opacity-100");
      tab.classList.remove("border-transparent", "opacity-70");

      productAccordionContents.forEach((content) =>
        content.classList.add("hidden")
      );
      productAccordionContents[index].classList.remove("hidden");
    });
  });

  // Initialize first tab as active
  productAccordionTabs[0]?.classList.add("border-navy", "opacity-100");
  productAccordionTabs[0]?.classList.remove("border-transparent", "opacity-70");
  productAccordionContents?.forEach((content) =>
    content.classList.add("hidden")
  );
  productAccordionContents[0]?.classList.remove("hidden");

  // Sticky conversion bar
  const stickyBar = document.querySelector(".sticky-conversion-bar");
  if (!stickyBar) return;

  window.addEventListener("scroll", () => {
    if (window.scrollY >= 600) {
      stickyBar.classList.remove("-bottom-full");
      stickyBar.classList.add("bottom-0");
    } else {
      stickyBar.classList.remove("bottom-0");
      stickyBar.classList.add("-bottom-full");
    }
  });
});

// Gift card script
const giftCardRadios = document.querySelectorAll(".gift-card-radio");
const GiftCardForm = document.querySelector("#GiftCardForm");

function filterButtons(selectedFormat) {
  const giftOptions = document.querySelectorAll('.multi-variant-dropdown');

  giftOptions.forEach((go) => {
    const giftOptionsButtons = Array.from(
      go.querySelectorAll('button[data-format]')
    );

    let previousPrice = null;
    const prevActive = giftOptionsButtons.find(
      (b) =>
        b.classList.contains('active') ||
        b.getAttribute('aria-selected') === 'true'
    );

    if (prevActive) {
      previousPrice =
        prevActive.dataset.variantPrice ||
        prevActive.getAttribute('data-variant-price');
    }

    giftOptionsButtons.forEach((btn) => {
      if (btn.dataset.format === selectedFormat) {
        btn.style.display = '';
      } else {
        btn.style.display = 'none';
      }
    });

    let candidate = null;
    if (previousPrice) {
      candidate = giftOptionsButtons.find((btn) => {
        const btnPrice =
          btn.dataset.variantPrice ||
          btn.getAttribute('data-variant-price');

        return (
          btn.dataset.format === selectedFormat &&
          btn.style.display !== 'none' &&
          btnPrice === previousPrice
        );
      });
    }

    if (!candidate) {
      candidate = giftOptionsButtons.find(
        (btn) =>
          btn.dataset.format === selectedFormat &&
          btn.style.display !== 'none'
      );
    }

    // 5) Клікнемо по варіанту, якщо знайшли
    if (candidate) candidate.click();
  });
}

function showFormByFormat(selectedFormat) {
  GiftCardForm.querySelectorAll(".gift-card-form-type").forEach((form) => {
    form.classList.add("hidden");
  });

  const activeForm = GiftCardForm.querySelector(
    "#GiftCardForm--" + selectedFormat
  );
  activeForm.classList.remove("hidden");
}

// Initial state (show only checked format)
const checkedRadio = document.querySelector('input[name="format"]:checked');
if (checkedRadio) {
  filterButtons(checkedRadio.value);
  showFormByFormat(checkedRadio.value);
}
// Update on radio change
giftCardRadios.forEach((radio) => {
  radio.addEventListener("change", (e) => {
    filterButtons(e.target.value);
    showFormByFormat(e.target.value);
  });
});

// Gift card validation
// Disable Add to Cart if required fields are invalid (Digital format)
(function () {
  const form = GiftCardForm;
  if (!form) return;

  const addButtons = document.querySelectorAll(".add-to-cart-gift-button");

  function isEmailValid(email) {
    if (!email) return false;
    // Simple but effective email pattern
    const re = /[^\s@]+@[^\s@]+\.[^\s@]+/;
    return re.test(String(email).toLowerCase());
  }

  function setAddToCartDisabledByGiftForm(disabled) {
    addButtons.forEach((btn) => {
      if (disabled) {
        btn.dataset.giftInvalid = "1";
        btn.disabled = true;
        btn.classList.add("bg-darkGrey", "text-white");
        btn.classList.remove("bg-accentBlue");
      } else {
        // Clear invalid flag and enable unless genuinely out of stock
        delete btn.dataset.giftInvalid;
        const labelText =
          (btn.querySelector(".button-text")?.innerText ||
            btn.innerText ||
            "").trim();
        if (labelText.toUpperCase() === "BACK IN STOCK SOON") {
          // Respect OUT OF STOCK state if set elsewhere
          btn.disabled = true;
          btn.classList.add("bg-darkGrey", "text-white");
          btn.classList.remove("bg-accentBlue");
        } else {
          btn.disabled = false;
          btn.classList.remove("bg-darkGrey", "text-white");
          btn.classList.add("bg-accentBlue");
        }
      }
    });
  }

  function toggleMessage(el, show) {
    if (!el) return;
    el.classList.toggle("hidden", !show);
  }

  function validateGiftCardForm() {
    // Determine active form by visibility
    const activeForm = form.querySelector(".gift-card-form-type:not(.hidden)");
    if (!activeForm) return true; // No visible form => nothing to validate

    // If Physical is active, there are no required inputs
    if (activeForm.id === "GiftCardForm--Physical") {
      return true;
    }

    // Digital required fields
    let valid = true;

    const toInput = activeForm.querySelector("#recipientName");
    const fromInput = activeForm.querySelector("#senderName");
    const emailInput = activeForm.querySelector("#recipientEmail");
    const dateInput = activeForm.querySelector("#deliveryDate");

    // To
    if (!toInput || toInput.value.trim() === "") {
      valid = false;
      toggleMessage(document.getElementById("ToMessage"), true);
    } else {
      toggleMessage(document.getElementById("ToMessage"), false);
    }

    // From
    if (!fromInput || fromInput.value.trim() === "") {
      valid = false;
      toggleMessage(document.getElementById("FromMessage"), true);
    } else {
      toggleMessage(document.getElementById("FromMessage"), false);
    }

    // Email
    if (!emailInput || !isEmailValid(emailInput.value.trim())) {
      valid = false;
      toggleMessage(document.getElementById("EmailMessage"), true);
    } else {
      toggleMessage(document.getElementById("EmailMessage"), false);
    }

    // Delivery date (required but no explicit message element)
    if (!dateInput || dateInput.value.trim() === "") {
      valid = false;
    }

    return valid;
  }

  function reevaluateGiftCardValidity() {
    const isValid = validateGiftCardForm();
    setAddToCartDisabledByGiftForm(!isValid);
  }

  // Wire up events for live validation
  const inputs = form.querySelectorAll(
    "#recipientName, #senderName, #recipientEmail, #deliveryDate"
  );
  inputs.forEach((inp) => {
    ["input", "change", "blur"].forEach((ev) =>
      inp.addEventListener(ev, reevaluateGiftCardValidity)
    );
  });

  // Revalidate on format change and when form visibility changes
  giftCardRadios.forEach((radio) => {
    radio.addEventListener("change", () => {
      // Give the UI a tick to flip visibility, then validate
      setTimeout(reevaluateGiftCardValidity, 0);
    });
  });

  // Initial evaluation
  // reevaluateGiftCardValidity();
})();
